import styled from 'styled-components/macro';

export const SelectedPerformerVenueContainer = styled.div`
  position: absolute;
  overflow: hidden;
  width: 100%;
  z-index: 2;
  box-shadow: 0px 10px 10px -5px ${(props) => props.theme.colors.textPrimary};
`;
